import { ImageCompareDesignTokens } from '@primeuix/themes/types/imagecompare';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/imagecompare/index.ts
const ic = componentCommon.imagecompare;

export const ImageCompareTelekomDT: ImageCompareDesignTokens = {
  handle: {
    size: t(ic.handle.size),
    hoverSize: t(ic.handle.hover.size),
    background: t(ic.handle.background),
    hoverBackground: t(ic.handle.hover.background),
    borderColor: t(ic.handle.border.color),
    hoverBorderColor: t(ic.handle.hover.border.color),
    borderWidth: t(ic.handle.border.width),
    borderRadius: t(ic.handle.border.radius),
    focusRing: {
      width: t(ic.handle.focus.ring.width),
      color: t(ic.handle.focus.ring.color),
      offset: t(ic.handle.focus.ring.offset),
    },
  },
};
